<template>
  <li>
    <p
      class="clickable ma-0 text-subtitle-1 d-flex align-center"
      @click="onSelectFolder(value)"
      :class="{ 'primary--text': selectId == value.id }"
    >
      <v-icon>
        mdi-folder
      </v-icon>
      {{ value.name }}
    </p>
    <ul v-if="hasChildren">
      <icon-folder-node
        v-for="child in value.children"
        :key="child.id"
        :value="child"
        :selectId="selectId"
        @click:select="onSelectFolder"
      />
    </ul>
  </li>
</template>

<script>
export default {
  name: 'icon-folder-node',
  props: {
    value: { type: Object, default: () => ({}), require: true },
    selectId: {},
  },
  data: () => ({}),
  computed: {
    hasChildren() {
      const { children } = this.value
      return children && children.length > 0
    },
  },
  methods: {
    onSelectFolder(folder) {
      this.$emit('click:select', folder)
    },
  },
}
</script>

<style scoped></style>
